import React from 'react';
import { Link } from 'react-router-dom';
import { Button, Dropdown } from 'antd';

import { buildActionMenu } from '../common/actionMenu';
import ItemAuditLine from '../items/ItemAuditLine';
import { GRID, KEBAB } from '../icons';
import { formatCount } from '../../utils/counts';
import { dashboardPath } from '../../utils/dashboards';
import { normalizeId } from '../../utils/ids';

/**
 * One dashboard on the Reports list (plan §6.1), in ChartRow's shape. Rows
 * are TEXT, never live thumbnails: listing a collection's dashboards runs
 * none of their charts. A row reads, left to right and down:
 *
 *   the dashboard's name — the door to its page
 *   its description, when it has one
 *   how many tiles it holds ("Empty" for none), and when it was made and
 *   changed (ItemAuditLine: who did each, in its pop-up)
 *
 * and its ⋯, in the action taxonomy (`actions`, from dashboardActions). The
 * tier is the section the row sits in.
 */
export default function DashboardRow({ dashboard, collectionId, actions }) {
	const id = normalizeId(dashboard?._id);
	const menu = buildActionMenu(actions || []);
	const tiles = formatCount(dashboard?.tileCount, 'tile') || 'Empty';
	const audit = {
		createdAt: dashboard?.createdAt,
		updatedAt: dashboard?.updatedAt,
		owner: dashboard?.createdBy,
		updatedBy: dashboard?.updatedBy,
	};
	return (
		<li className='reports-row reports-row--dashboard' data-dashboard-id={id}>
			<div className='reports-row__main'>
				<Link className='reports-row__name' to={dashboardPath(collectionId, id)}>{dashboard?.name || 'Untitled dashboard'}</Link>
				{dashboard?.description ? <p className='reports-row__description'>{dashboard.description}</p> : null}
				<div className='reports-row__meta'>
					<span className='reports-row__form'>
						<GRID aria-hidden='true' className='reports-row__form-glyph' />
						{tiles}
					</span>
					<ItemAuditLine item={audit} className='reports-row__audit' />
				</div>
			</div>
			{menu ? (
				<Dropdown trigger={['click']} placement='bottomRight' menu={menu}>
					<Button className='reports-row__more' icon={<KEBAB />} aria-label={`More actions for ${dashboard?.name || 'this dashboard'}`} />
				</Dropdown>
			) : null}
		</li>
	);
}
